"use client";

import type { CSSProperties } from "react";

import "./SectionLoader.scss";

type SectionLoaderProps = {
  minHeight?: string;
  className?: string;
  style?: CSSProperties;
};

export default function SectionLoader({
  minHeight = "240px",
  className,
  style,
}: SectionLoaderProps) {
  return (
    <div
      className={`section-loader ${className ?? ""}`.trim()}
      style={{ minHeight, ...style }}
      aria-busy
      aria-label="Loading"
    />
  );
}
